// import { setRTLStatus } from '@bybit/rtl-plugin';

import { BYBIT_LANG_KEY } from './common/storage';
/**
 * RTL布局相关语言
 */
// const RTLList = ['en', 'en-US'];
const RTLList = ['ar-SA'];

let rtlPlugin: any = null;

const getRtlPlugin = async () => {
  if (rtlPlugin) {
    return rtlPlugin;
  }
  rtlPlugin = (await import('@bybit/rtl-plugin')).default;
  return rtlPlugin;
};

/**
 * 当前local是否为RTL布局
 */
export const isRTL = (locale: string) => {
  return RTLList.includes(locale);
};

/**
 * 通过local获取dir属性值
 */
export const getDirValue = async (locale: string) => {
  const rtlStatis = isRTL(locale);
  const { setRTLStatus } = await getRtlPlugin();
  setRTLStatus(rtlStatis);
  return rtlStatis ? 'rtl' : 'ltr';
};

/**
 * rtl适配
 */
export const rtlAdapter = () => {
  getDirValue(localStorage.getItem(BYBIT_LANG_KEY) as string).then(
    (statis: string) => {
      document.documentElement.dir = statis;
    },
  );
  // document.documentElement.dir = 'rtl';
};

export const reactRTLJsInit = async (params: any) => {
  const { reactRTLJsInit } = await getRtlPlugin();
  reactRTLJsInit(params);
};
